<template>
  <div>
    <home-profile />
    <home-contract />
  </div>
</template>

<script>
/* eslint-disable */
import { BCol, BRow } from 'bootstrap-vue'

import HomeContract from './HomeContract.vue'
import HomeProfile from './HomeProfile.vue'

export default {
    components: {
        BRow,
        BCol,
        HomeProfile,
        HomeContract,
    },
    data() {
        return {}
    },
    created() {},
    methods: {},
}
</script>
